export function hourValidator(string: string, position: number): boolean {
  return true;
}
